import { DetalisationTooltip } from '@/modules/common/components/detalisation-tooltip';
import { humidityLvlColor } from '@/modules/common/utils/get-humidity-color';
import { BestPriceBuyerItem, IBestPriceBagItem } from '@/modules/mixing/store/analytical-mixing.store';
import { Humidity } from '@/shared/ui/icons';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import styles from './index.module.sass';
import rotateArrowIcon from '@@/mixing/components/recipes-detail/icons/rotate-arrow.svg';
import { RubleRegular } from '@/modules/common/components/ruble-regular';

export const BuyerInfo = ({ className, offer, data, TARGET_MOISTURE }: { className?: string, data: IBestPriceBagItem, offer?: BestPriceBuyerItem, TARGET_MOISTURE: number }) => {
    const navigate = useNavigate();
    return (
        <div className={classNames(styles.buyerInfo, className)}>
            <div className={styles.topInfo}>
              <span className={styles.buyerLabel}>
                <Tooltip title={offer?.buyer}>{offer?.buyer}</Tooltip>
              </span>
              <span className={styles.action} style={{ marginLeft: '4px' }}>
                заменить покупателя
                <img src={rotateArrowIcon} className={styles.icon} />
              </span>
            </div>
            <div className={styles.bottomArea}>
              <div className={styles.col}>
                <span className={styles.label}>цена</span>
                <span className={styles.value}>
                  {offer?.price_per_ton.toLocaleString('ru')} <RubleRegular customSymbol='₽/т' p={0}/> 
                </span>
              </div>
              <div className={styles.col}>
                <span className={styles.label}>
                  логистика{' '}
                  {!offer?.freight_price && !offer?.distance ? (
                    <DetalisationTooltip
                      status={data.status as any}
                      rangeKm={offer?.distance}
                      navigate={navigate}
                    />
                  ) : !offer.freight_price && offer.distance ? (
                    <DetalisationTooltip
                      status={data.status as any}
                      rangeKm={offer?.distance}
                      red={true}
                      navigate={navigate}
                    />
                  ) : (
                    ''
                  )}
                </span>
                <span className={styles.value}>
                  {!offer?.freight_price && !offer?.distance ? (
                    <span className={styles.selfDelivery}>
                      {data.status === 'BuyerPickupEnforced'
                        ? 'самовывоз'
                        : 'по договоренности'}
                    </span>
                  ) : (
                    <>
                      {offer?.freight_price?.toLocaleString('ru', {
                        maximumFractionDigits: 0,
                      }) || '0'}{' '}
                      <RubleRegular p={0}/>{' '}
                      <span className={styles.innerRegular}>
                        {Number(offer?.distance)?.toLocaleString('ru', {
                          maximumFractionDigits: 0,
                        }) || '0'}{' '}
                        км
                      </span>
                    </>
                  )}
                </span>
              </div>
              <div className={styles.col}>
                <span className={styles.label}>влажность</span>
                <span className={classNames(styles.value, styles.humidity)}>
                  <Humidity fill={humidityLvlColor(TARGET_MOISTURE)} />{' '}
                  {TARGET_MOISTURE}%
                </span>
              </div>
            </div>
          </div>
    )
}